import { List, Typography } from 'antd';
import { useTranslation } from 'react-i18next';
import { ClientGroup } from '../../models/client-group';

interface Props {
  isFetchingClientGroups: boolean;
  clientGroupsDataSource: ClientGroup[];
}

const ClientGroupList = ({ isFetchingClientGroups, clientGroupsDataSource }: Props): JSX.Element => {
  const { t } = useTranslation('common');

  return (
    <List
      loading={isFetchingClientGroups}
      bordered={true}
      itemLayout="vertical"
      dataSource={clientGroupsDataSource}
      renderItem={item => (
        <List.Item>
          <div>
            <Typography.Text strong>{t('label.name')}: </Typography.Text>
            {item.name}
          </div>
          <div>
            <Typography.Text strong>{t('label.users')}: </Typography.Text>
            {item.users}
          </div>
          <div>
            <Typography.Text strong>{t('label.templates')}: </Typography.Text>
            {item.templates}
          </div>
        </List.Item>
      )}
    />
  );
};
export default ClientGroupList;
